export default "__VITE_ASSET__CaMdZNjV__"